const getMilbTvUrl = ({ urlRoot, gamePk, deepLinkPrefix, isApp }) => {
    return isApp ? `${deepLinkPrefix}milbtv?gamepk=${gamePk}` : `${urlRoot}/live-stream-games/g${gamePk}`;
};

export default getMilbTvUrl;